// Welle 119 — gemeinsame Hilfen der Seite „Rechnungen" (Rechnung schreiben, Ausgangsbuch, Arbeitszeit-Auswahl)
import { API_BASE } from "../../api/config";

export const API = `${API_BASE}/mietverwaltung/api/rechnung`;

export const zahl = (v) => {
  if (v === null || v === undefined || v === "") return 0;
  if (typeof v === "number") return v;
  const s = String(v).trim().replace(/\s/g, "").replace(/€/g, "");
  const n = s.includes(",") ? Number(s.replace(/\./g, "").replace(",", ".")) : Number(s);
  return Number.isFinite(n) ? n : 0;
};

export const euro = (v) => `${(Math.round(zahl(v) * 100) / 100).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

export const deDatum = (iso) => (iso ? String(iso).slice(0, 10).split("-").reverse().join(".") : "");

export async function json(r) {
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.detail || `Fehler ${r.status}`);
  return d;
}
